const init = () => {
    const search = document.querySelector('.search');
    const searchMenu = document.querySelector('.search-menu');
    const hamburger = document.querySelector('.hamburger');
    const header = document.querySelector('.header-menu');
    const menuOverlay = document.querySelector('.menu-overlay');
  
    // This helper function updates the overlay
    const updateOverlay = () => {
      if (searchMenu.classList.contains('is-active') || header.classList.contains('is-active')) {
        menuOverlay.classList.add('is-active');
      } else {
        menuOverlay.classList.remove('is-active');
      }
    };
  
    // Toggle search menu when the search icon is clicked
    search.addEventListener('click', () => {
      search.classList.toggle('is-active');
      searchMenu.classList.toggle('is-active');
  
      // Ensure the header menu is closed
      hamburger.classList.remove('is-active');
      header.classList.remove('is-active');
  
      updateOverlay();
    });
  
    // Toggle header menu when the hamburger is clicked
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('is-active');
      header.classList.toggle('is-active');
  
      // Ensure the search menu is closed
      search.classList.remove('is-active');
      searchMenu.classList.remove('is-active');
  
      updateOverlay();
    });
  
    // When clicking on the overlay, close both menus
    menuOverlay.addEventListener('click', () => {
      search.classList.remove('is-active');
      searchMenu.classList.remove('is-active');
      hamburger.classList.remove('is-active');
      header.classList.remove('is-active');
  
      updateOverlay();
    });
  };
  
  export default init;
  